var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { dashboardWorkerRef } from "src/apis/dashboard.controller";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import styles from "../../components/navbar/navbarOne.module.scss";
const MarketStatus = ({ marketStatusModal, toggleMarketStatusModal, }) => {
    const [marketStatus, setMarketStatus] = useState([]);
    const fetchMarketStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const responseData = yield dashboardWorkerRef.getMarketStatusImpl();
            setMarketStatus(responseData.data.body.Data);
        }
        catch (err) {
            console.error(err);
        }
    });
    useEffect(() => {
        fetchMarketStatus();
    }, []);
    const fetchUserRights = (description) => {
        const getStatusFromLocal = getDataFromSession(SESSION_KEYS.USERMARKETENABLED) || {};
        let userRights = "";
        switch (description) {
            case "Nse Cash":
                userRights = getStatusFromLocal.AllowNseCash;
                break;
            case "Nse Derivative":
                userRights = getStatusFromLocal.AllowNseDeriv;
                break;
            case "Bse Cash":
                userRights = getStatusFromLocal.AllowBseCash;
                break;
            case "Nse Currency":
                userRights = getStatusFromLocal.AllowNSECurrency;
                break;
            case "Bse Derivative":
                userRights = getStatusFromLocal.AllowBseDeriv;
                break;
            case "MCX":
                userRights = getStatusFromLocal.AllowMCXComm;
                break;
        }
        return userRights;
    };
    const marketStatusTag = (status) => {
        let statusCSS = "";
        if (status === "Open")
            statusCSS = styles.openTag;
        if (status === "Closed")
            statusCSS = styles.closeTag;
        return {
            statusCSS,
        };
    };
    return (_jsxs(Modal, Object.assign({ isOpen: marketStatusModal, onRequestClose: toggleMarketStatusModal, className: styles.myCommonModal, overlayClassName: styles.myCommonOverlay }, { children: [_jsxs("div", Object.assign({ className: `${styles.modalHeaderPart}` }, { children: [_jsx("h6", Object.assign({ className: "mb-0 large" }, { children: "Market Status" })), _jsx("span", { className: "closeIcon", onClick: () => toggleMarketStatusModal() })] })), _jsx("div", Object.assign({ className: `${styles.modalBodyPart} ${styles.marketStatusTableScroll} p-0` }, { children: _jsxs("table", Object.assign({ className: `${styles.marketStatusTable}`, cellPadding: "0", cellSpacing: "0" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", { children: ["Exchange ", _jsx("span", { className: "sortArrow ms-1" })] }), _jsxs("th", { children: ["Status ", _jsx("span", { className: "sortArrow ms-1" })] }), _jsxs("th", { children: ["User Rights ", _jsx("span", { className: "sortArrow ms-1" })] })] }) }), _jsx("tbody", { children: marketStatus.map((data, index) => (_jsxs("tr", { children: [_jsx("td", { children: data.ExchDescription }), _jsx("td", { children: _jsx("span", Object.assign({ className: marketStatusTag(data.MarketStatus).statusCSS }, { children: data.MarketStatus })) }), _jsx("td", { children: fetchUserRights(data.ExchDescription) })] }, index))) })] })) }))] })));
};
export default MarketStatus;
